import React, {useEffect, useState} from 'react'
import {Div} from "../../../registroMaternidad/modales/components/Components";
import InputText from "../../../../components/modalComponents/InputText";
import InputDate from "../../../../components/modalComponents/InputDate";
import {CAMPANA_KEYS} from "./campanaKeys";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import InputSelect from "../../../../components/modalComponents/InputSelect";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {
    cuadroRequerimientosGetAniosForCrearEditarCampanaAPI, cuadroRequerimientosGetAvailablePresupuestosAPI,
    cuadroRequerimientosGetIdsCampanasForCrearCampanaAPI, cuadroRequerimientosGetIdsCampanasForEditarCampanaAPI,

} from "../../../../consumers/backendApisUrls";
import {initialAllOptionPromises} from "../../../../helper/utils";
import {useGetOptionsSelect} from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import {EXTENSION_PDF} from "../../../../constants/hardCodedConstants";
import {AlertErrorMaxFileSizeMessageGeneric} from "../../../../components/alerts/AlertErrorMaxFileSizeMessage";

const Campana = ( {formValuesCampana,
                  setFormValuesCampana,
                  isEditable,
                  isCreate,
                  SECTION_NAME,
                  idCampana
                  }) => {

    const [commonProps] = usePropsInputs(formValuesCampana, setFormValuesCampana, SECTION_NAME);
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [getOption] = useGetOptionsSelect();
    const [isUploading, setIsUploading] = useState(false);


    const KEYS_DROPDOWN = [
        "Anio",
        "IdCampanaPrevia",
        "IdPresupuestoRequerimiento"
    ];

    const getDropdowns = async () => {
        let apiForCampanaPrevia = isCreate ?
            cuadroRequerimientosGetIdsCampanasForCrearCampanaAPI() :
            cuadroRequerimientosGetIdsCampanasForEditarCampanaAPI(idCampana);

        let apiForGetPresupuestos = isCreate ?
            cuadroRequerimientosGetAvailablePresupuestosAPI() :
            cuadroRequerimientosGetAvailablePresupuestosAPI(idCampana)


        const dropdownsPromises = () => [
            getOption(cuadroRequerimientosGetAniosForCrearEditarCampanaAPI()),
            getOption(apiForCampanaPrevia),
            getOption(apiForGetPresupuestos)
        ]
        await initialAllOptionPromises(dropdownsPromises, KEYS_DROPDOWN, handleDropdowns);
    }

    const handleDropdowns = (data) => {
        setAllDropdowns([...data]);
    }

    const [selectProps] = usePropsSelect(
        allDropdowns,
        formValuesCampana,
        setFormValuesCampana,
        SECTION_NAME
    );



    useEffect(() => {
            getDropdowns()
        }
        , [])

    return (
        <>
            <Div col={12}>
                <InputText
                    label={"Nombre"}
                    name={"Nombre"}
                    {...commonProps(CAMPANA_KEYS.Nombre)}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isRequired={true}
                    isDisabled={!isEditable}
                />
            </Div>
            <Div col={6}>
                <InputDate
                    label={"Fecha de inicio"}
                    name={CAMPANA_KEYS.FechaInicio}
                    max={formValuesCampana[CAMPANA_KEYS.FechaFin]}
                    {...commonProps(CAMPANA_KEYS.FechaInicio)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    direction="column"
                />
            </Div>
            <Div col={6}>
                <InputDate
                    label={"Fecha de fin"}
                    name={CAMPANA_KEYS.FechaFin}
                    min={formValuesCampana[CAMPANA_KEYS.FechaInicio]  }
                    {...commonProps(CAMPANA_KEYS.FechaFin)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    direction="column"

                />
            </Div>


            <Div col={6}>
                <InputDate
                    label={"Fecha Cierre Desarrollo"}
                    name={CAMPANA_KEYS.FechaCierreDesarrollo}
                    {...commonProps(CAMPANA_KEYS.FechaCierreDesarrollo)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    direction="column"

                />
            </Div>
            <Div col={6}>

                {isEditable &&
                    <InputSelect
                        label="Año"
                        {...selectProps(CAMPANA_KEYS.Anio)}
                        sectionName={SECTION_NAME}
                        isDisabled={!isEditable}
                        isRequired={true}
                        placeholder={"Seleccionar Año"}
                        direction="column"
                    />
                }

                {!isEditable &&
                    <InputText
                        label={"Año"}
                        name={"Año"}
                        {...commonProps(CAMPANA_KEYS.Anio)}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isRequired={true}
                        isDisabled={!isEditable}
                    />
                }

            </Div>
            <Div col={6}>
                <InputSelect
                    label="Campana Previa"
                    {...selectProps(CAMPANA_KEYS.IdCampanaPrevia)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    placeholder={"Seleccionar Campana Previa"}
                    direction="column"
                />
            </Div>

            <Div col={6}>
                <InputSelect
                    label="Presupuesto"
                    {...selectProps(CAMPANA_KEYS.IdPresupuestoRequerimiento)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    placeholder={"Seleccionar Presupuesto"}
                    direction="column"
                />
            </Div>


            <Div col={6}>
                <InputText
                    label={"Ratio Eficiencia"}
                    name={"RatioEficiencia"}
                    {...commonProps(CAMPANA_KEYS.RatioEficiencia)}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isRequired={true}
                    isDisabled={!isEditable}
                />
            </Div>

            <Div col={6}>
                <InputUploadFile
                    label="Guía Proceso"
                    name={CAMPANA_KEYS.CRCampanaGuiaProcesoFileViewModel}
                    uploadFile={formValuesCampana[CAMPANA_KEYS.CRCampanaGuiaProcesoFileViewModel]}
                    setUploadFile={(res) =>
                        setFormValuesCampana({...formValuesCampana, [CAMPANA_KEYS.CRCampanaGuiaProcesoFileViewModel]: res})
                    }
                    sectionName={SECTION_NAME}
                    setIsUploading={setIsUploading}
                    validExtensions={EXTENSION_PDF}
                    isDisabled={isUploading}
                    direction="column"
                    NoFileMessage={isUploading ? "Subiendo archivo..." : "No se ha subido archivo"}
                    maxFileSize ={2097152} //2MB
                    ToastArchivoNoValido = {() => AlertErrorMaxFileSizeMessageGeneric( 'pdf' , '2MB')}
                    isRequired
                />
            </Div>
            <Div col={6}>
            </Div>        
        </>
    );
}

export default Campana;